/***
 * 创建人：ls
 * 时间：2019-08-26
 * 描述：验证输入值中是否只包含中文或英文字符
 */
import { Directive } from '@angular/core';
import { AbstractControl } from '@angular/forms';
@Directive({
  selector: '[appValidatorCharType]'
})
export class ValidatorCharTypeDirective {

  constructor() { }
  
  charType(type : string) {
    return (control:AbstractControl) => {
      let v = control.value;
      if(!v || v==""){
        return null;
      }else{
        switch (type) {
          case 'chinese':{
            const reg = /^[\u4e00-\u9fa5]{1,}$/;
            if(!reg.test(v)){
              return {
                charType : true
              };
            }else{
              return null;
            }
          };
          case 'english':{
            const reg = /^[a-zA-Z]{1,}$/;
            if(!reg.test(v)){
              return {
                charType : true
              };
            }else{
              return null;
            }
          };
          default:
            break;
        }
      }
    }
  }
}
